import apiClient from './client'
import type { GroupMonthlyPayments } from '../types/monthly_payment'

export const monthlyPaymentsApi = {
  /** Get payment statuses for all athletes in a group for a given month */
  getGroupMonthly(groupId: string, yearMonth: string): Promise<GroupMonthlyPayments> {
    return apiClient.get(`/groups/${groupId}/monthly-payments/${yearMonth}`).then((r) => r.data)
  },

  /** Toggle athlete payment status for a given month */
  togglePayment(
    groupId: string,
    athleteId: string,
    yearMonth: string,
    isPaid: boolean
  ): Promise<{ id: string; is_paid: boolean; paid_at?: string }> {
    return apiClient
      .put(`/groups/${groupId}/monthly-payments/${athleteId}/${yearMonth}`, { is_paid: isPaid })
      .then((r) => r.data)
  },

  /** Get group monthly price */
  getMonthlyPrice(groupId: string): Promise<{ monthly_price: number | null }> {
    return apiClient.get(`/groups/${groupId}/monthly-price/`).then((r) => r.data)
  },

  /** Set group monthly price */
  setMonthlyPrice(groupId: string, monthlyPrice: number | null): Promise<void> {
    return apiClient.put(`/groups/${groupId}/monthly-price/`, { monthly_price: monthlyPrice })
  },
}
